export const noDefaultArchivePolicyText = "lWd";
export const noDefaultDeletePolicyText = "mWd";
export const useParentFolderPolicyText = "nWd";
export default {noDefaultArchivePolicyText,noDefaultDeletePolicyText,useParentFolderPolicyText};